import React from 'react'
import Title from '../../title/title.jsx'

const description10 = () => {
  return (
    <div>
      <Title text="Resmi Tercüme Hizmetleri – Yazılı ve Sözlü (Simultane & Ardıl)" size='l' align='left'/>
      <p>Resmi tercüman olarak, Almanca – Türkçe ve Türkçe – Almanca dillerinde hem yazılı hem de sözlü tercüme hizmeti sunuyorum.</p>
      <p>Resmi kurumlar, mahkemeler, konsolosluklar ve iş görüşmeleri gibi kritik süreçlerde doğru ve eksiksiz iletişim büyük önem taşır. Bu noktada profesyonel desteğimle yanınızdayım.</p>
      <Title text="Hizmetlerim:" size='s' align='left'/> 
      <ul>
        <li>Yazılı Tercüme</li>
        <li>Doğum, evlilik ve boşanma belgeleri</li>
        <li>Diploma ve denklik evrakları</li>
        <li>Oturum ve çalışma izinleri</li>
        <li>Mahkeme kararları ve hukuki belgeler</li>
        <li>Sözleşmeler ve resmi yazışmalar</li>
        <li>Sözlü Tercüme (Dolmetschen)</li>
        <li>Resmi kurum görüşmeleri (Ausländerbehörde vb.)</li>
        <li>Konsolosluk randevuları</li>
        <li>Mahkeme ve avukat görüşmeleri</li>
        <li>İş görüşmeleri</li>
        <li>Noter işlemleri</li>
      </ul>
      <Title text="Neden Ben?" size='s' align='left'/> 
      <p>Resmi tercümanlık deneyimi</p>
      <p>Göç, vize ve hukuki süreçlere hâkimiyet</p>
      <p>Hassas ve kritik görüşmelerde profesyonel iletişim</p>
      <p>Güvenilir ve hızlı hizmet</p>
      <br />  
      <p>Sadece tercüme değil, aynı zamanda sürecin doğru yönetilmesi için de aktif destek sağlıyorum.</p>
    </div>
  )
}

export default description10